import ClientAdmin from './client-admin/client-admin';
import ClientEdit from './client-edit/client-edit';
import EnterData from './enter-data/enter-data';
import EnterVirtualData from './enter-virtual-data/enter-virtual-data';
import FacilityReporting from './facility-reporting/facility-reporting';
import Home from './home/home';
import UserAdmin from './user-admin/user-admin';
import SiteLookup from './site-lookup/site-lookup';

const components = angular
    .module('Components', [
        ClientAdmin,
        ClientEdit,
        EnterData,
        EnterVirtualData,
        FacilityReporting,
        Home,
        SiteLookup,
        UserAdmin
    ])
    .name;

export default components;



// WEBPACK FOOTER //
// ./app/components/components.js